import React, { ReactNode } from 'react';
import { classNames } from '../../utils/style';
import { DefaultBsComponent } from '../../types/module';
import { Image } from '../../components/Image';
import { ImageProps } from '../Image/types';

export interface ButtonCardProps extends DefaultBsComponent {
  image?: Omit<ImageProps, 'sizes'>;
  button?: ReactNode;
  className?: string;
}

export const ButtonCard = ({
  image,
  className,
  button,
  as: Component = 'div',
  ...props
}: ButtonCardProps) => {
  const _image = {
    ...image,
    sizes: image?.sizes || [
      '(min-width: 768px) 300px',
      '(min-width: 1024px) 360px',
      '299px',
    ],
  } as ImageProps;
  return (
    <Component
      {...props}
      className={classNames(
        'ButtonCard',
        'group overflow-hidden',
        'flex rounded-18 hover:shadow-m',
        'flex-col',
        'border border-neutral-51',
        className,
      )}
    >
      {image && <Image {..._image} className="flex h-full w-full" />}
      <div className={classNames('rounded-b-18 px-40 py-32')}>
        {button && button}
      </div>
    </Component>
  );
};
